"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPersonName = void 0;
const formatPersonName = (...parts) => parts
    .map((part) => (typeof part === 'string' ? part.trim() : ''))
    .filter(Boolean)
    .join(' ');
exports.formatPersonName = formatPersonName;
